import { ProjectTeamMember } from "./ProjectTeamMember";
import { Department } from "../department";
import { NameSpecifiedEntity } from "../entity";

export class ProjectTeam extends NameSpecifiedEntity<number> {
  constructor(public id: number, public name: string, public kanaName: string, public department: Department, public members: ProjectTeamMember[], public isDeleted: boolean) {
    super(id, name);
  }

  clone(): ProjectTeam {
    return new ProjectTeam(this.id, this.name, this.kanaName, this.department, this.members, this.isDeleted);
  }
}
